import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

interface Props {
  open: boolean;
  title?: string;
  content: string | React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  closeBtnText?: string;
  confirmBtnText?: string;
  // Extra data-* attributes forwarded to the Dialog root — e.g. so the AI
  // auto-mode intercept listener in AIStatusBar can be told to ignore this
  // dialog (it renders in a portal, outside any already-ignored container).
  [dataAttr: `data-${string}`]: string | undefined;
}

export default function ConfirmDialog({
  open,
  title,
  content,
  onClose,
  onConfirm,
  closeBtnText = 'Close',
  confirmBtnText = 'Confirm',
  ...rest
}: Props) {
  const handleClose = (_event: React.MouseEvent, reason: string) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.key === 'Enter') {
      if (onConfirm) {
        onConfirm();
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      onKeyDown={handleKeyDown}
      onClick={(e) => {
        e.stopPropagation();
      }}
      {...rest}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {closeBtnText}
        </Button>
        {onConfirm && (
          <Button onClick={onConfirm} variant="contained">
            {confirmBtnText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
